export default function convertMinutesToHoursAndMinutes(minutes) {
    const sign = Math.sign(minutes);
    const absMinutes = Math.abs(minutes);
    const hours = Math.floor(absMinutes / 60);
    const remainingMinutes = absMinutes % 60;

    return `${sign * hours}:${remainingMinutes < 10 ? '0' : ''}${remainingMinutes}`;
}
